<template>
  <v-card outlined class="project-card pa-3">
    <div class="caption text-uppercase text--secondary mb-2">
      <v-icon>mdi-note-edit-outline</v-icon>
      Informations projet
    </div>
    <v-row dense>
      <v-col cols="12">
        <v-textarea
          v-model="local.description"
          label="Description"
          dense
          rows="4"
          outlined
          hide-details="auto"
        />
      </v-col>

      <v-col cols="12">
        <v-textarea
          v-model="local.usage"
          label="Usage"
          rows="2"
          dense
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12">
        <div class="caption text-uppercase text--secondary mb-2">Contraintes</div>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="local.feu"
          label="Contrainte feu"
          prepend-icon="mdi-fire-extinguisher"
          dense
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="local.acoustique"
          label="Contrainte acoustique"
          prepend-icon="mdi-music-off"
          dense
          outlined
          hide-details="auto"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="local.humidite"
          label="Humidité"
          prepend-icon="mdi-water-alert"
          dense
          outlined
          hide-details="auto"
        />
      </v-col>
    </v-row>

    <template v-if="value.documents_used && value.documents_used.length">
      <div class="caption text--secondary mt-3">Documents</div>
      <div class="mt-1">
        <v-chip
          v-for="(d, i) in value.documents_used"
          :key="i"
          x-small
          outlined
          color="grey"
          class="mr-1 mb-1"
        >
          <v-icon x-small left>mdi-file-document-outline</v-icon>{{ d }}
        </v-chip>
      </div>
    </template>
  </v-card>
</template>

<script>
export default {
  name: 'ProjectCard',
  props: {
    value: { type: Object, required: true },
  },
  data() {
    const c = this.value.constraints || {}
    return {
      local: {
        description: this.value.description || '',
        usage: this.value.usage || '',
        feu: c.feu || '',
        acoustique: c.acoustique || '',
        humidite: c.humidite || '',
      },
    }
  },
  watch: {
    local: {
      deep: true,
      handler(v) {
        this.$emit('input', {
          ...this.value,
          description: v.description,
          usage: v.usage,
          constraints: {
            feu: v.feu || null,
            acoustique: v.acoustique || null,
            humidite: v.humidite || null,
          },
        })
      },
    },
  },
}
</script>

<style scoped>
.project-card {
  background: var(--app-card-bg, #fff);
}
</style>
